import moment from 'moment-timezone'
import { isArray, isNumber, isString, pickBy } from 'lodash-es'
import { buildQuery } from '@calendly/http-tools'

const buildConfigurationParams = (eventType) => eventType.redirect_configuration.params

const buildBookingParams = (eventType, event, invitee) => ({
  assigned_to: event.assigned_to.join(','),
  event_type_uuid: eventType.uuid,
  event_type_name: eventType.name,
  event_start_time: moment(event.start_time).tz(invitee.timezone).format(),
  event_end_time: moment(event.end_time).tz(invitee.timezone).format(),
  invitee_uuid: invitee.uuid,
  invitee_first_name: invitee.first_name,
  invitee_last_name: invitee.last_name,
  invitee_full_name: invitee.full_name,
  invitee_email: invitee.email,
  text_reminder_number: invitee.phone_number,
  guests: event.guests
})

const buildPaymentParams = (invitee) => {
  const { charge } = invitee
  if (!charge) {
    return undefined
  }
  return {
    invitee_payment_amount: charge.amount,
    invitee_payment_currency: charge.currency
  }
}

const buildEventFields = (event) => event.event_fields.reduce((memo, field) => {
  const key = `answer_${field.position + 1}`
  memo[key] = field.value
  return memo
}, {})

const isParamValue = (value) => {
  if (isNumber(value)) {
    return true
  }
  if (isString(value) && value.length) {
    return true
  }
  return Boolean(isArray(value) && value.length)
}

const shouldAddBookingMetaDataParams = (eventType) => eventType.redirect_configuration.pass_booking_details

const buildBookingMetaData = (eventType, event, invitee, tracking) => ({
  ...buildBookingParams(eventType, event, invitee),
  ...buildPaymentParams(invitee),
  ...buildEventFields(event),
  ...tracking
})

const buildRedirectAndBookingMetaDataParams = (eventType, event, invitee, tracking) => {
  let params = { ...buildConfigurationParams(eventType) }

  if (shouldAddBookingMetaDataParams(eventType)) {
    params = {
      ...params,
      ...buildBookingMetaData(eventType, event, invitee, tracking)
    }
  }

  return pickBy(params, (value) => isParamValue(value))
}

export default (eventType, event, invitee, tracking) => {
  const params = buildRedirectAndBookingMetaDataParams(eventType, event, invitee, tracking)
  const query = buildQuery(params, { addQueryPrefix: true })
  const fragment = eventType.redirect_configuration.fragment
  const anchor = fragment ? `#${fragment}` : ''
  const linkInterstitialsEnabled = eventType.link_interstitials_enabled

  // Wrapped links already include redirect parameters in the query string
  // Only booking meta data params need to be appended if pass_booking_details is true
  if (linkInterstitialsEnabled) {
    const bookingMetaDataQuery = shouldAddBookingMetaDataParams(eventType)
      ? buildQuery(buildBookingMetaData(eventType, event, invitee, tracking), { addQueryPrefix: false })
      : ''

    return eventType.redirect_configuration.url + (bookingMetaDataQuery ? `&${bookingMetaDataQuery}` : '') + anchor
  }

  return eventType.redirect_configuration.url + query + anchor
}
